export default __webpack_public_path__ + "static/media/LI.ecb7841b.svg";